import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProductServicePricingPlan, ProtectionPlanPricingPlan } from 'models';

@Injectable({
	providedIn: 'root',
})
export class PricingPlanService {
	constructor(private http: HttpClient) {}

	public getProductServicePricingPlans(clientId: string): Observable<ProductServicePricingPlan[]> {
		return this.http.get<ProductServicePricingPlan[]>(`api/pricingplan/get/${clientId}`);
	}

	public getProtectionPlanPricingPlans(clientId: string): Observable<ProtectionPlanPricingPlan[]> {
		return this.http.get<ProtectionPlanPricingPlan[]>(`api/protectionplanpricing/get/${clientId}`);
	}
}
